import styled from "styled-components";
import { Row, Input, Button } from "antd";
const { TextArea } = Input;

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: col;
`;

export const DetailSection = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.div`
  width: 70%;
  font-size: 35px;
  line-height: normal;
  margin-bottom: 20px;
`;

export const SubTitle = styled.div`
  width: 70%;
  font-size: 18px;
  color: gray;
  font-weight: 500;
  margin-bottom: 40px;
`;

export const InfoBox = styled.div`
  background: white;
  height: 120px;
  width: 70%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 20px;
  margin-bottom: 40px;
`;

export const Details = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 30px;
  align-items: center;
  height: 100%;
`;

export const FormSection = styled.div`
  width: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FormBox = styled.div`
  min-height: 600px;
  width: 480px;
  margin: 30px;
  padding: 40px;
  float: right;
  background: linear-gradient(0deg, #38176c, #3e304e);;
  border-radius: 10px;
`;

export const FormTitle = styled.div`
  font-size: 28px;
  color: white;
`;

export const FormSubTitle = styled.div`
  font-size: 18px;
  color: #be9be3;
`;

export const RowField = styled(Row)`
  margin: 20px 0 20px 0;
`;

export const InputField = styled(Input)`
  height: 50px;
  border-radius: 8px;
  font-size: 18px;
`;

export const TextareaField = styled(TextArea)`
  border-radius: 8px;
  font-size: 18px;
`;

export const FormButton = styled(Button)`
  height: 55px;
  width: 100%;
  margin-top: 10px;
  border-radius: 8px;
  font-size: 18px;
  background: #d91212;
  color: white;
  border: none;
  font-weight: 500;

  &:hover {
    border: none;
    background: red;
    color: white;
  }
  :focus {
    border: none;
    background: red;
    color: white;
  }
  :active {
    border: none;
    background: red;
    color: white;
  }
`;

export const Logo = styled.img`
`;